export enum ProfessionLicenseTypeEnum {
  BPILicense = 'BPI License',
  HomeScoreLicense = 'Home Score License',
  T24License = 'T24 License'
}
